// Mock data for the entire application

export const currentUser = {
  id: '1',
  email: 'john.doe@example.com',
  name: 'John Doe',
  role: 'candidate', // candidate, company, admin
  avatar: 'https://i.pravatar.cc/150?img=1'
};

export const jobListings = [
  {
    id: '1', companyId: '101', companyName: 'TechCorp AI',
    companyLogo: 'https://ui-avatars.com/api/?name=TechCorp+AI&background=6366F1&color=fff',
    title: 'Expert Senior SWE', category: 'Software Engineering',
    description: 'We are looking for an experienced Senior Software Engineer to work on cutting-edge AI projects.',
    requirements: ['5+ years experience', 'Python/JavaScript', 'ML/AI knowledge', 'Remote work experience'],
    payRange: { min: 150, max: 210 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ['Python', 'TensorFlow', 'AWS', 'Docker'], status: 'active',
    applicationsCount: 34, hiredCount: 585, referralBonus: 600,
    avatars: ['https://i.pravatar.cc/150?img=1','https://i.pravatar.cc/150?img=2','https://i.pravatar.cc/150?img=3'],
    createdAt: '2025-01-05'
  },
  {
    id: '2', companyId: '102', companyName: 'DataMinds',
    companyLogo: 'https://ui-avatars.com/api/?name=DataMinds&background=8B5CF6&color=fff',
    title: 'Exceptional Software Engineer (Linux)', category: 'Software Engineering',
    description: 'Join our team to build scalable infrastructure for AI workloads.',
    requirements: ['Linux expertise', '3+ years DevOps', 'Kubernetes', 'Terraform'],
    payRange: { min: 85, max: 120 }, payRate: 'hourly', location: 'Remote', type: 'Contract',
    skills: ['Linux', 'Kubernetes', 'CI/CD', 'Python'], status: 'active',
    applicationsCount: 41, hiredCount: 879, referralBonus: 140,
    avatars: ['https://i.pravatar.cc/150?img=4','https://i.pravatar.cc/150?img=5','https://i.pravatar.cc/150?img=6'],
    createdAt: '2025-01-10'
  },
  {
    id: '3', companyId: '103', companyName: 'GlobalTech',
    companyLogo: 'https://ui-avatars.com/api/?name=GlobalTech&background=EC4899&color=fff',
    title: 'Procurement Expert', category: 'Operations',
    description: 'Manage procurement processes for AI hardware and software.',
    requirements: ['Supply chain experience', 'Vendor management', 'Contract negotiation'],
    payRange: { min: 60, max: 100 }, payRate: 'hourly', location: 'Hybrid', type: 'Part-time',
    skills: ['Procurement', 'Negotiation', 'SAP', 'Excel'], status: 'active',
    applicationsCount: 44, hiredCount: 225, referralBonus: 140,
    avatars: ['https://i.pravatar.cc/150?img=7','https://i.pravatar.cc/150?img=8','https://i.pravatar.cc/150?img=9'],
    createdAt: '2025-01-12'
  },
  {
    id: '4', companyId: '104', companyName: 'AI Research Lab',
    companyLogo: 'https://ui-avatars.com/api/?name=AI+Research+Lab&background=10B981&color=fff',
    title: "Mathematics Expert (Master's / PhD)", category: 'Research & Science',
    description: 'Work on advanced mathematical models for machine learning.',
    requirements: ["Master's or PhD in Mathematics", 'Research experience', 'Publications preferred'],
    payRange: { min: 60, max: 80 }, payRate: 'hourly', location: 'Remote', type: 'Contract',
    skills: ['Mathematics', 'Statistics', 'Python', 'Research'], status: 'active',
    applicationsCount: 69, hiredCount: 69, referralBonus: 200,
    avatars: ['https://i.pravatar.cc/150?img=10','https://i.pravatar.cc/150?img=11','https://i.pravatar.cc/150?img=12'],
    createdAt: '2025-01-15'
  },
  {
    id: '5', companyId: '105', companyName: 'ConsultCo',
    companyLogo: 'https://ui-avatars.com/api/?name=ConsultCo&background=F59E0B&color=fff',
    title: 'Management Consultants', category: 'Consulting',
    description: 'Strategic consulting for AI transformation projects.',
    requirements: ['MBA or equivalent', 'Consulting experience', 'AI strategy knowledge'],
    payRange: { min: 90, max: 200 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ['Strategy', 'Consulting', 'AI', 'Change Management'], status: 'active',
    applicationsCount: 86, hiredCount: 454, referralBonus: 520,
    avatars: ['https://i.pravatar.cc/150?img=13','https://i.pravatar.cc/150?img=14','https://i.pravatar.cc/150?img=15'],
    createdAt: '2025-01-18'
  },
  {
    id: '6', companyId: '106', companyName: 'PyTech Solutions',
    companyLogo: 'https://ui-avatars.com/api/?name=PyTech+Solutions&background=3B82F6&color=fff',
    title: 'Backend Software Engineer: Python', category: 'Software Engineering',
    description: 'Build robust backend systems for AI applications.',
    requirements: ['Python expert', 'FastAPI/Django', 'PostgreSQL', 'Redis'],
    payRange: { min: 80, max: 120 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ['Python', 'FastAPI', 'PostgreSQL', 'Docker'], status: 'active',
    applicationsCount: 24, hiredCount: 136, referralBonus: 320,
    avatars: ['https://i.pravatar.cc/150?img=16','https://i.pravatar.cc/150?img=17','https://i.pravatar.cc/150?img=18'],
    createdAt: '2025-01-20'
  },
  {
    id: '7', companyId: '107', companyName: 'DataScience Pro',
    companyLogo: 'https://ui-avatars.com/api/?name=DataScience+Pro&background=EF4444&color=fff',
    title: 'Expert Data Scientist', category: 'Data Science',
    description: 'Lead data science initiatives and mentor junior team members.',
    requirements: ['PhD preferred', '5+ years DS experience', 'ML deployment', 'Team leadership'],
    payRange: { min: 100, max: 150 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ['Python', 'ML', 'Statistics', 'Leadership'], status: 'active',
    applicationsCount: 29, hiredCount: 96, referralBonus: 400,
    avatars: ['https://i.pravatar.cc/150?img=19','https://i.pravatar.cc/150?img=20','https://i.pravatar.cc/150?img=21'],
    createdAt: '2025-01-22'
  },
  {
    id: '8', companyId: '108', companyName: 'Academic Bridge',
    companyLogo: 'https://ui-avatars.com/api/?name=Academic+Bridge&background=8B5CF6&color=fff',
    title: 'Rehan STEM PhD Transfer', category: 'Research & Science',
    description: 'Support PhD candidates transitioning to industry.',
    requirements: ['STEM PhD', 'Research background', 'Industry interest'],
    payRange: { min: 70, max: 80 }, payRate: 'hourly', location: 'Remote', type: 'Part-time',
    skills: ['Research', 'Python', 'Communication'], status: 'active',
    applicationsCount: 38, hiredCount: 38, referralBonus: 200,
    avatars: ['https://i.pravatar.cc/150?img=22','https://i.pravatar.cc/150?img=23','https://i.pravatar.cc/150?img=24'],
    createdAt: '2025-01-25'
  },
  {
    id: '9', companyId: '109', companyName: 'MedAI Corp',
    companyLogo: 'https://ui-avatars.com/api/?name=MedAI&background=14B8A6&color=fff',
    title: 'Radiologist Experts', category: 'Healthcare',
    description: 'AI-assisted radiology analysis and quality assurance.',
    requirements: ['Board-certified Radiologist', 'AI familiarity', '5+ years clinical'],
    payRange: { min: 40, max: 50 }, payRate: 'hourly', location: 'Remote', type: 'Part-time',
    skills: ['Radiology', 'Medical Imaging', 'AI', 'Diagnostics'], status: 'active',
    applicationsCount: 12, hiredCount: 12, referralBonus: 200,
    avatars: [], createdAt: '2025-01-26'
  },
  {
    id: '10', companyId: '110', companyName: 'TrajectoryAI',
    companyLogo: 'https://ui-avatars.com/api/?name=Trajectory&background=F97316&color=fff',
    title: 'Software Engineer (Trajectory)', category: 'Software Engineering',
    description: 'Work on trajectory planning and optimization systems.',
    requirements: ['C++/Python', 'Robotics background', 'Math skills'],
    payRange: { min: 70, max: 130 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ['C++', 'Python', 'Robotics', 'Optimization'], status: 'active',
    applicationsCount: 50, hiredCount: 454, referralBonus: 520,
    avatars: ['https://i.pravatar.cc/150?img=25','https://i.pravatar.cc/150?img=26','https://i.pravatar.cc/150?img=27'],
    createdAt: '2025-01-27'
  },
  {
    id: '11', companyId: '111', companyName: 'FrontendMasters',
    companyLogo: 'https://ui-avatars.com/api/?name=Frontend&background=A855F7&color=fff',
    title: 'Software Engineer (Front-end)', category: 'Software Engineering',
    description: 'Build next-gen frontend interfaces for AI tools.',
    requirements: ['React/Vue expert', 'TypeScript', 'UI/UX sense'],
    payRange: { min: 70, max: 80 }, payRate: 'hourly', location: 'Hybrid', type: 'Full-time',
    skills: ['React', 'TypeScript', 'CSS', 'Figma'], status: 'active',
    applicationsCount: 30, hiredCount: 136, referralBonus: 320,
    avatars: ['https://i.pravatar.cc/150?img=28','https://i.pravatar.cc/150?img=29','https://i.pravatar.cc/150?img=30'],
    createdAt: '2025-01-28'
  },
  {
    id: '12', companyId: '112', companyName: 'CardioAI',
    companyLogo: 'https://ui-avatars.com/api/?name=CardioAI&background=EF4444&color=fff',
    title: 'Cardiologist Experts', category: 'Healthcare',
    description: 'AI-enhanced cardiac diagnostics and research.',
    requirements: ['Board-certified Cardiologist', 'Clinical experience'],
    payRange: { min: 40, max: 50 }, payRate: 'hourly', location: 'Remote', type: 'Part-time',
    skills: ['Cardiology', 'ECG', 'Medical AI'], status: 'active',
    applicationsCount: 8, hiredCount: 8, referralBonus: 200,
    avatars: [], createdAt: '2025-01-29'
  },
  {
    id: '13', companyId: '113', companyName: 'DevTools Inc',
    companyLogo: 'https://ui-avatars.com/api/?name=DevTools&background=06B6D4&color=fff',
    title: 'Software Expert (Development & Programming)', category: 'Software Engineering',
    description: 'Full-stack development and programming expertise.',
    requirements: ['5+ years development', 'Multiple languages', 'System design'],
    payRange: { min: 65, max: 65 }, payRate: 'hourly', location: 'Remote', type: 'Contract',
    skills: ['JavaScript', 'Python', 'Go', 'System Design'], status: 'active',
    applicationsCount: 52, hiredCount: 52, referralBonus: 260,
    avatars: ['https://i.pravatar.cc/150?img=31','https://i.pravatar.cc/150?img=32','https://i.pravatar.cc/150?img=33'],
    createdAt: '2025-02-01'
  },
  {
    id: '14', companyId: '114', companyName: 'SciComp Labs',
    companyLogo: 'https://ui-avatars.com/api/?name=SciComp&background=84CC16&color=fff',
    title: 'Software Expert (Scientific and Analytical)', category: 'Research & Science',
    description: 'Scientific computing and analytical software development.',
    requirements: ['PhD in STEM', 'Scientific computing', 'HPC experience'],
    payRange: { min: 100, max: 100 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ['Python', 'MATLAB', 'HPC', 'Statistics'], status: 'active',
    applicationsCount: 30, hiredCount: 96, referralBonus: 400,
    avatars: ['https://i.pravatar.cc/150?img=34','https://i.pravatar.cc/150?img=35','https://i.pravatar.cc/150?img=36'],
    createdAt: '2025-02-03'
  },
  {
    id: '15', companyId: '115', companyName: 'RedTeam Security',
    companyLogo: 'https://ui-avatars.com/api/?name=RedTeam&background=DC2626&color=fff',
    title: 'AI Red-Teamer - Adversarial AI Testing', category: 'AI & Machine Learning',
    description: 'Adversarial testing and red-teaming for AI models.',
    requirements: ['AI/ML knowledge', 'Security mindset', 'Creative thinking'],
    payRange: { min: 50, max: 111 }, payRate: 'hourly', location: 'Remote', type: 'Contract',
    skills: ['AI Security', 'Prompt Engineering', 'Python', 'Red Teaming'], status: 'active',
    applicationsCount: 5, hiredCount: 1, referralBonus: 450,
    avatars: ['https://i.pravatar.cc/150?img=37'], createdAt: '2025-02-05'
  },
  {
    id: '16', companyId: '116', companyName: 'ML Dynamics',
    companyLogo: 'https://ui-avatars.com/api/?name=ML+Dynamics&background=7C3AED&color=fff',
    title: 'Machine Learning Engineer', category: 'AI & Machine Learning',
    description: 'Design and deploy ML models at scale.',
    requirements: ['ML frameworks', 'Model deployment', 'Data pipelines'],
    payRange: { min: 100, max: 120 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ['PyTorch', 'TensorFlow', 'MLOps', 'Python'], status: 'active',
    applicationsCount: 73, hiredCount: 73, referralBonus: 480,
    avatars: ['https://i.pravatar.cc/150?img=38','https://i.pravatar.cc/150?img=39','https://i.pravatar.cc/150?img=40'],
    createdAt: '2025-02-07'
  },
  {
    id: '17', companyId: '117', companyName: 'SysDesign Co',
    companyLogo: 'https://ui-avatars.com/api/?name=SysDesign&background=0EA5E9&color=fff',
    title: 'Software Engineering & Systems Design Expert', category: 'Software Engineering',
    description: 'Architecture and systems design for distributed systems.',
    requirements: ['10+ years SWE', 'System design expertise', 'Cloud architecture'],
    payRange: { min: 45, max: 80 }, payRate: 'hourly', location: 'Hybrid', type: 'Full-time',
    skills: ['System Design', 'AWS', 'Microservices', 'Kubernetes'], status: 'active',
    applicationsCount: 2, hiredCount: 2, referralBonus: 320,
    avatars: ['https://i.pravatar.cc/150?img=41','https://i.pravatar.cc/150?img=42'],
    createdAt: '2025-02-08'
  },
  {
    id: '18', companyId: '118', companyName: 'OS Experts',
    companyLogo: 'https://ui-avatars.com/api/?name=OS+Experts&background=475569&color=fff',
    title: 'Software Expert (Operating System)', category: 'Software Engineering',
    description: 'Low-level systems programming and OS development.',
    requirements: ['C/C++ mastery', 'Kernel development', 'Systems programming'],
    payRange: { min: 100, max: 100 }, payRate: 'hourly', location: 'Remote', type: 'Contract',
    skills: ['C', 'C++', 'Linux Kernel', 'Assembly'], status: 'active',
    applicationsCount: 59, hiredCount: 59, referralBonus: 400,
    avatars: ['https://i.pravatar.cc/150?img=43','https://i.pravatar.cc/150?img=44','https://i.pravatar.cc/150?img=45'],
    createdAt: '2025-02-10'
  },
  {
    id: '19', companyId: '119', companyName: 'Listening Labs',
    companyLogo: 'https://ui-avatars.com/api/?name=Listening&background=F43F5E&color=fff',
    title: 'Listening', category: 'Media & Content',
    description: 'Audio analysis and content evaluation specialist.',
    requirements: ['Linguistics background', 'Audio analysis', 'Attention to detail'],
    payRange: { min: 30, max: 35 }, payRate: 'hourly', location: 'Remote', type: 'Part-time',
    skills: ['Linguistics', 'Audio Analysis', 'NLP'], status: 'active',
    applicationsCount: 200, hiredCount: 879, referralBonus: 140,
    avatars: ['https://i.pravatar.cc/150?img=46','https://i.pravatar.cc/150?img=47','https://i.pravatar.cc/150?img=48'],
    createdAt: '2025-02-12'
  },
  {
    id: '20', companyId: '120', companyName: 'MediaAI',
    companyLogo: 'https://ui-avatars.com/api/?name=MediaAI&background=D946EF&color=fff',
    title: 'Media Analysis Specialists', category: 'Media & Content',
    description: 'Analyze and evaluate media content for AI training.',
    requirements: ['Media background', 'Analytical skills', 'Content expertise'],
    payRange: { min: 30, max: 35 }, payRate: 'hourly', location: 'Remote', type: 'Part-time',
    skills: ['Media Analysis', 'Content Evaluation', 'Writing'], status: 'active',
    applicationsCount: 60, hiredCount: 225, referralBonus: 140,
    avatars: ['https://i.pravatar.cc/150?img=49','https://i.pravatar.cc/150?img=50','https://i.pravatar.cc/150?img=51'],
    createdAt: '2025-02-14'
  },
  {
    id: '21', companyId: '121', companyName: 'LegalTech AI',
    companyLogo: 'https://ui-avatars.com/api/?name=LegalTech&background=7C3AED&color=fff',
    title: 'Lawyers', category: 'Legal',
    description: 'Legal document review and AI-assisted case analysis.',
    requirements: ['JD degree', 'Bar admission', '3+ years practice'],
    payRange: { min: 90, max: 150 }, payRate: 'hourly', location: 'Remote', type: 'Contract',
    skills: ['Legal Research', 'Contract Law', 'AI Tools'], status: 'active',
    applicationsCount: 45, hiredCount: 312, referralBonus: 600,
    avatars: ['https://i.pravatar.cc/150?img=52','https://i.pravatar.cc/150?img=53','https://i.pravatar.cc/150?img=54'],
    createdAt: '2025-02-16'
  },
  {
    id: '22', companyId: '122', companyName: 'FinanceAI',
    companyLogo: 'https://ui-avatars.com/api/?name=FinanceAI&background=059669&color=fff',
    title: 'Financial Analysts', category: 'Finance',
    description: 'AI-powered financial modeling and market analysis.',
    requirements: ['CFA or MBA', 'Financial modeling', 'Python/R'],
    payRange: { min: 80, max: 130 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ['Financial Analysis', 'Python', 'Excel', 'Bloomberg'], status: 'active',
    applicationsCount: 38, hiredCount: 189, referralBonus: 500,
    avatars: ['https://i.pravatar.cc/150?img=55','https://i.pravatar.cc/150?img=56','https://i.pravatar.cc/150?img=57'],
    createdAt: '2025-02-18'
  },
  {
    id: '23', companyId: '123', companyName: 'NLP Works',
    companyLogo: 'https://ui-avatars.com/api/?name=NLP+Works&background=2563EB&color=fff',
    title: 'NLP Research Scientist', category: 'AI & Machine Learning',
    description: 'Advance natural language processing research for production systems.',
    requirements: ['PhD in NLP/CL', 'Published research', 'PyTorch expertise'],
    payRange: { min: 120, max: 180 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ['NLP', 'Transformers', 'PyTorch', 'Research'], status: 'active',
    applicationsCount: 22, hiredCount: 67, referralBonus: 700,
    avatars: ['https://i.pravatar.cc/150?img=58','https://i.pravatar.cc/150?img=59','https://i.pravatar.cc/150?img=60'],
    createdAt: '2025-02-20'
  },
  {
    id: '24', companyId: '124', companyName: 'CloudScale',
    companyLogo: 'https://ui-avatars.com/api/?name=CloudScale&background=0891B2&color=fff',
    title: 'Cloud Infrastructure Engineer', category: 'Software Engineering',
    description: 'Design and manage cloud infrastructure at scale.',
    requirements: ['AWS/GCP certified', 'Terraform', 'Kubernetes'],
    payRange: { min: 90, max: 140 }, payRate: 'hourly', location: 'Remote', type: 'Contract',
    skills: ['AWS', 'Terraform', 'Kubernetes', 'CI/CD'], status: 'active',
    applicationsCount: 41, hiredCount: 234, referralBonus: 450,
    avatars: ['https://i.pravatar.cc/150?img=61','https://i.pravatar.cc/150?img=62','https://i.pravatar.cc/150?img=63'],
    createdAt: '2025-02-22'
  },
  {
    id: '25', companyId: '125', companyName: 'BioTech Labs',
    companyLogo: 'https://ui-avatars.com/api/?name=BioTech&background=16A34A&color=fff',
    title: 'Bioinformatics Specialist', category: 'Research & Science',
    description: 'Computational biology and genomics data analysis.',
    requirements: ['PhD in Bioinformatics', 'Genomics pipelines', 'R/Python'],
    payRange: { min: 75, max: 110 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ['Bioinformatics', 'R', 'Python', 'Genomics'], status: 'active',
    applicationsCount: 19, hiredCount: 45, referralBonus: 350,
    avatars: ['https://i.pravatar.cc/150?img=64','https://i.pravatar.cc/150?img=65'],
    createdAt: '2025-02-24'
  },
  {
    id: '26', companyId: '126', companyName: 'EdTech Pro',
    companyLogo: 'https://ui-avatars.com/api/?name=EdTech&background=CA8A04&color=fff',
    title: 'Curriculum Designer - AI Education', category: 'Education',
    description: 'Design AI-focused curricula for online learning platforms.',
    requirements: ['Education background', 'AI/ML knowledge', 'Content creation'],
    payRange: { min: 55, max: 75 }, payRate: 'hourly', location: 'Remote', type: 'Part-time',
    skills: ['Curriculum Design', 'AI/ML', 'LMS', 'Content Writing'], status: 'active',
    applicationsCount: 33, hiredCount: 128, referralBonus: 250,
    avatars: ['https://i.pravatar.cc/150?img=66','https://i.pravatar.cc/150?img=67','https://i.pravatar.cc/150?img=68'],
    createdAt: '2025-02-26'
  },
  {
    id: '27', companyId: '127', companyName: 'CyberGuard AI',
    companyLogo: 'https://ui-avatars.com/api/?name=CyberGuard&background=DC2626&color=fff',
    title: 'Cybersecurity Analyst', category: 'Security',
    description: 'AI-powered threat detection and cybersecurity operations.',
    requirements: ['CISSP/CEH', 'SOC experience', 'Python scripting'],
    payRange: { min: 85, max: 120 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ['Cybersecurity', 'SIEM', 'Python', 'Threat Intel'], status: 'active',
    applicationsCount: 27, hiredCount: 156, referralBonus: 400,
    avatars: ['https://i.pravatar.cc/150?img=10','https://i.pravatar.cc/150?img=11','https://i.pravatar.cc/150?img=12'],
    createdAt: '2025-02-28'
  },
  {
    id: '28', companyId: '128', companyName: 'QuantumAI',
    companyLogo: 'https://ui-avatars.com/api/?name=QuantumAI&background=7C3AED&color=fff',
    title: 'Quantum Computing Researcher', category: 'Research & Science',
    description: 'Research quantum algorithms for AI optimization.',
    requirements: ['PhD in Physics/CS', 'Quantum computing', 'Qiskit/Cirq'],
    payRange: { min: 130, max: 200 }, payRate: 'hourly', location: 'Remote', type: 'Contract',
    skills: ['Quantum Computing', 'Qiskit', 'Python', 'Linear Algebra'], status: 'active',
    applicationsCount: 11, hiredCount: 23, referralBonus: 800,
    avatars: ['https://i.pravatar.cc/150?img=13','https://i.pravatar.cc/150?img=14'],
    createdAt: '2025-03-01'
  },
  {
    id: '29', companyId: '129', companyName: 'ContentAI',
    companyLogo: 'https://ui-avatars.com/api/?name=ContentAI&background=EC4899&color=fff',
    title: 'Content Strategist - AI Tools', category: 'Media & Content',
    description: 'Develop content strategies leveraging AI writing tools.',
    requirements: ['5+ years content marketing', 'AI tools experience', 'SEO'],
    payRange: { min: 50, max: 75 }, payRate: 'hourly', location: 'Remote', type: 'Part-time',
    skills: ['Content Strategy', 'SEO', 'AI Writing', 'Analytics'], status: 'active',
    applicationsCount: 56, hiredCount: 340, referralBonus: 300,
    avatars: ['https://i.pravatar.cc/150?img=15','https://i.pravatar.cc/150?img=16','https://i.pravatar.cc/150?img=17'],
    createdAt: '2025-03-03'
  },
  {
    id: '30', companyId: '130', companyName: 'RoboticsTech',
    companyLogo: 'https://ui-avatars.com/api/?name=Robotics&background=0D9488&color=fff',
    title: 'Robotics Software Engineer', category: 'Software Engineering',
    description: 'Build software for autonomous robotic systems.',
    requirements: ['C++/Python', 'ROS', 'Computer Vision', 'Motion Planning'],
    payRange: { min: 100, max: 160 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ['ROS', 'C++', 'Computer Vision', 'Motion Planning'], status: 'active',
    applicationsCount: 35, hiredCount: 198, referralBonus: 550,
    avatars: ['https://i.pravatar.cc/150?img=18','https://i.pravatar.cc/150?img=19','https://i.pravatar.cc/150?img=20'],
    createdAt: '2025-03-05'
  },
  {
    id: '31', companyId: '131', companyName: 'DataViz Corp',
    companyLogo: 'https://ui-avatars.com/api/?name=DataViz&background=8B5CF6&color=fff',
    title: 'Data Visualization Expert', category: 'Data Science',
    description: 'Create compelling data visualizations and dashboards.',
    requirements: ['D3.js/Tableau', 'Statistics', 'UX Design sense'],
    payRange: { min: 65, max: 95 }, payRate: 'hourly', location: 'Remote', type: 'Contract',
    skills: ['D3.js', 'Tableau', 'Python', 'Statistics'], status: 'active',
    applicationsCount: 42, hiredCount: 267, referralBonus: 350,
    avatars: ['https://i.pravatar.cc/150?img=21','https://i.pravatar.cc/150?img=22','https://i.pravatar.cc/150?img=23'],
    createdAt: '2025-03-07'
  },
  {
    id: '32', companyId: '132', companyName: 'TranslateAI',
    companyLogo: 'https://ui-avatars.com/api/?name=Translate&background=2563EB&color=fff',
    title: 'Bilingual AI Trainer - Spanish', category: 'Language',
    description: 'Train AI language models for Spanish-English translation.',
    requirements: ['Native Spanish', 'Fluent English', 'Linguistics background'],
    payRange: { min: 35, max: 50 }, payRate: 'hourly', location: 'Remote', type: 'Part-time',
    skills: ['Spanish', 'English', 'Linguistics', 'AI Training'], status: 'active',
    applicationsCount: 89, hiredCount: 567, referralBonus: 200,
    avatars: ['https://i.pravatar.cc/150?img=24','https://i.pravatar.cc/150?img=25','https://i.pravatar.cc/150?img=26'],
    createdAt: '2025-03-09'
  },
  {
    id: '33', companyId: '133', companyName: 'HealthData',
    companyLogo: 'https://ui-avatars.com/api/?name=HealthData&background=14B8A6&color=fff',
    title: 'Clinical Data Annotator', category: 'Healthcare',
    description: 'Annotate medical data for AI model training.',
    requirements: ['Medical background', 'Data annotation experience', 'Attention to detail'],
    payRange: { min: 40, max: 60 }, payRate: 'hourly', location: 'Remote', type: 'Part-time',
    skills: ['Medical Data', 'Annotation', 'Healthcare', 'QA'], status: 'active',
    applicationsCount: 64, hiredCount: 412, referralBonus: 250,
    avatars: ['https://i.pravatar.cc/150?img=27','https://i.pravatar.cc/150?img=28','https://i.pravatar.cc/150?img=29'],
    createdAt: '2025-03-11'
  },
  {
    id: '34', companyId: '134', companyName: 'GameAI Studio',
    companyLogo: 'https://ui-avatars.com/api/?name=GameAI&background=F97316&color=fff',
    title: 'Game AI Developer', category: 'Software Engineering',
    description: 'Develop AI systems for next-gen gaming experiences.',
    requirements: ['Unity/Unreal', 'AI/ML for games', 'C#/C++'],
    payRange: { min: 70, max: 110 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ['Unity', 'C#', 'Game AI', 'Reinforcement Learning'], status: 'active',
    applicationsCount: 31, hiredCount: 145, referralBonus: 400,
    avatars: ['https://i.pravatar.cc/150?img=30','https://i.pravatar.cc/150?img=31','https://i.pravatar.cc/150?img=32'],
    createdAt: '2025-03-13'
  },
  {
    id: '35', companyId: '135', companyName: 'AutoDrive AI',
    companyLogo: 'https://ui-avatars.com/api/?name=AutoDrive&background=1D4ED8&color=fff',
    title: 'Autonomous Vehicle Engineer', category: 'Software Engineering',
    description: 'Build perception and planning systems for self-driving cars.',
    requirements: ['Computer Vision', 'Sensor Fusion', 'C++/Python'],
    payRange: { min: 110, max: 170 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ['Computer Vision', 'LiDAR', 'C++', 'Deep Learning'], status: 'active',
    applicationsCount: 18, hiredCount: 78, referralBonus: 650,
    avatars: ['https://i.pravatar.cc/150?img=33','https://i.pravatar.cc/150?img=34','https://i.pravatar.cc/150?img=35'],
    createdAt: '2025-03-15'
  },
  {
    id: '36', companyId: '136', companyName: 'EthicsAI',
    companyLogo: 'https://ui-avatars.com/api/?name=EthicsAI&background=9333EA&color=fff',
    title: 'AI Ethics Researcher', category: 'Research & Science',
    description: 'Research and develop ethical AI frameworks and policies.',
    requirements: ['Philosophy/Ethics PhD', 'AI knowledge', 'Policy writing'],
    payRange: { min: 60, max: 90 }, payRate: 'hourly', location: 'Remote', type: 'Part-time',
    skills: ['AI Ethics', 'Policy', 'Research', 'Writing'], status: 'active',
    applicationsCount: 15, hiredCount: 34, referralBonus: 300,
    avatars: ['https://i.pravatar.cc/150?img=36','https://i.pravatar.cc/150?img=37'],
    createdAt: '2025-03-17'
  },
  {
    id: '37', companyId: '137', companyName: 'VoiceAI',
    companyLogo: 'https://ui-avatars.com/api/?name=VoiceAI&background=DB2777&color=fff',
    title: 'Speech Recognition Engineer', category: 'AI & Machine Learning',
    description: 'Build and improve speech recognition and synthesis systems.',
    requirements: ['ASR experience', 'Deep Learning', 'Signal Processing'],
    payRange: { min: 85, max: 130 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ['ASR', 'TTS', 'PyTorch', 'Signal Processing'], status: 'active',
    applicationsCount: 24, hiredCount: 112, referralBonus: 450,
    avatars: ['https://i.pravatar.cc/150?img=38','https://i.pravatar.cc/150?img=39','https://i.pravatar.cc/150?img=40'],
    createdAt: '2025-03-19'
  },
  {
    id: '38', companyId: '138', companyName: 'SupplyChain AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Supply&background=0284C7&color=fff',
    title: 'Supply Chain Optimization Analyst', category: 'Finance',
    description: 'Apply AI to optimize global supply chain operations.',
    requirements: ['Supply chain experience', 'Operations Research', 'Python'],
    payRange: { min: 70, max: 100 }, payRate: 'hourly', location: 'Remote', type: 'Contract',
    skills: ['Operations Research', 'Python', 'Supply Chain', 'Optimization'], status: 'active',
    applicationsCount: 37, hiredCount: 189, referralBonus: 350,
    avatars: ['https://i.pravatar.cc/150?img=41','https://i.pravatar.cc/150?img=42','https://i.pravatar.cc/150?img=43'],
    createdAt: '2025-03-21'
  },
  {
    id: '39', companyId: '139', companyName: 'DevRel AI',
    companyLogo: 'https://ui-avatars.com/api/?name=DevRel&background=4F46E5&color=fff',
    title: 'Developer Advocate - AI Platform', category: 'Media & Content',
    description: 'Build developer community and create technical content.',
    requirements: ['Developer relations experience', 'Public speaking', 'Technical writing'],
    payRange: { min: 60, max: 85 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ['DevRel', 'Technical Writing', 'Public Speaking', 'AI'], status: 'active',
    applicationsCount: 48, hiredCount: 223, referralBonus: 300,
    avatars: ['https://i.pravatar.cc/150?img=44','https://i.pravatar.cc/150?img=45','https://i.pravatar.cc/150?img=46'],
    createdAt: '2025-03-23'
  },
  {
    id: '40', companyId: '140', companyName: 'BlockchainAI',
    companyLogo: 'https://ui-avatars.com/api/?name=BlockAI&background=EA580C&color=fff',
    title: 'Blockchain & AI Integration Engineer', category: 'Software Engineering',
    description: 'Build decentralized AI systems on blockchain infrastructure.',
    requirements: ['Solidity', 'Smart Contracts', 'ML/AI knowledge', 'Web3'],
    payRange: { min: 100, max: 160 }, payRate: 'hourly', location: 'Remote', type: 'Contract',
    skills: ['Solidity', 'Web3', 'Python', 'Smart Contracts'], status: 'active',
    applicationsCount: 20, hiredCount: 89, referralBonus: 550,
    avatars: ['https://i.pravatar.cc/150?img=47','https://i.pravatar.cc/150?img=48','https://i.pravatar.cc/150?img=49'],
    createdAt: '2025-03-25'
  },
  {
    id: '41', companyId: '141', companyName: 'PharmAI',
    companyLogo: 'https://ui-avatars.com/api/?name=PharmAI&background=059669&color=fff',
    title: 'Pharmaceutical Research Analyst', category: 'Healthcare',
    description: 'AI-assisted drug discovery and pharmaceutical research.',
    requirements: ['PharmD or PhD', 'Drug discovery experience', 'Data analysis'],
    payRange: { min: 80, max: 120 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ['Drug Discovery', 'Chemistry', 'Python', 'ML'], status: 'active',
    applicationsCount: 16, hiredCount: 56, referralBonus: 450,
    avatars: ['https://i.pravatar.cc/150?img=50','https://i.pravatar.cc/150?img=51'],
    createdAt: '2025-03-27'
  },
  {
    id: '42', companyId: '142', companyName: 'DesignAI',
    companyLogo: 'https://ui-avatars.com/api/?name=DesignAI&background=A855F7&color=fff',
    title: 'UX/UI Designer - AI Products', category: 'Design',
    description: 'Design intuitive interfaces for AI-powered products.',
    requirements: ['5+ years UX/UI', 'Figma', 'AI product experience'],
    payRange: { min: 60, max: 90 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ['Figma', 'UX Research', 'UI Design', 'Prototyping'], status: 'active',
    applicationsCount: 53, hiredCount: 298, referralBonus: 350,
    avatars: ['https://i.pravatar.cc/150?img=52','https://i.pravatar.cc/150?img=53','https://i.pravatar.cc/150?img=54'],
    createdAt: '2025-03-29'
  },
  {
    id: '43', companyId: '143', companyName: 'TranslateAI Pro',
    companyLogo: 'https://ui-avatars.com/api/?name=TransPro&background=2563EB&color=fff',
    title: 'Bilingual AI Trainer - Mandarin', category: 'Language',
    description: 'Train AI language models for Mandarin-English tasks.',
    requirements: ['Native Mandarin', 'Fluent English', 'AI/ML familiarity'],
    payRange: { min: 40, max: 55 }, payRate: 'hourly', location: 'Remote', type: 'Part-time',
    skills: ['Mandarin', 'English', 'NLP', 'AI Training'], status: 'active',
    applicationsCount: 72, hiredCount: 445, referralBonus: 220,
    avatars: ['https://i.pravatar.cc/150?img=55','https://i.pravatar.cc/150?img=56','https://i.pravatar.cc/150?img=57'],
    createdAt: '2025-03-31'
  },
  {
    id: '44', companyId: '144', companyName: 'ComplianceAI',
    companyLogo: 'https://ui-avatars.com/api/?name=Compliance&background=475569&color=fff',
    title: 'AI Compliance Officer', category: 'Legal',
    description: 'Ensure AI systems comply with regulations and standards.',
    requirements: ['Legal/compliance background', 'AI regulations knowledge', 'Audit experience'],
    payRange: { min: 75, max: 110 }, payRate: 'hourly', location: 'Remote', type: 'Contract',
    skills: ['Compliance', 'AI Regulations', 'GDPR', 'Risk Assessment'], status: 'active',
    applicationsCount: 21, hiredCount: 89, referralBonus: 400,
    avatars: ['https://i.pravatar.cc/150?img=58','https://i.pravatar.cc/150?img=59'],
    createdAt: '2025-04-02'
  },
  {
    id: '45', companyId: '145', companyName: 'AgriTech AI',
    companyLogo: 'https://ui-avatars.com/api/?name=AgriTech&background=16A34A&color=fff',
    title: 'Agricultural AI Specialist', category: 'Research & Science',
    description: 'Apply AI/ML to precision agriculture and crop optimization.',
    requirements: ['Agriculture/Biology degree', 'Remote sensing', 'ML experience'],
    payRange: { min: 55, max: 80 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ['Agriculture', 'Remote Sensing', 'Python', 'ML'], status: 'active',
    applicationsCount: 29, hiredCount: 134, referralBonus: 300,
    avatars: ['https://i.pravatar.cc/150?img=60','https://i.pravatar.cc/150?img=61','https://i.pravatar.cc/150?img=62'],
    createdAt: '2025-04-04'
  },
  {
    id: '46', companyId: '146', companyName: 'MarketingAI',
    companyLogo: 'https://ui-avatars.com/api/?name=Marketing&background=EC4899&color=fff',
    title: 'AI Marketing Strategist', category: 'Media & Content',
    description: 'Develop AI-driven marketing campaigns and strategies.',
    requirements: ['Digital marketing expertise', 'AI tools proficiency', 'Analytics'],
    payRange: { min: 55, max: 80 }, payRate: 'hourly', location: 'Remote', type: 'Part-time',
    skills: ['Digital Marketing', 'AI Tools', 'Analytics', 'SEO'], status: 'active',
    applicationsCount: 67, hiredCount: 378, referralBonus: 280,
    avatars: ['https://i.pravatar.cc/150?img=63','https://i.pravatar.cc/150?img=64','https://i.pravatar.cc/150?img=65'],
    createdAt: '2025-04-06'
  },
  {
    id: '47', companyId: '147', companyName: 'TeleHealth AI',
    companyLogo: 'https://ui-avatars.com/api/?name=TeleHealth&background=0891B2&color=fff',
    title: 'Telemedicine AI Specialist', category: 'Healthcare',
    description: 'Build AI-powered telemedicine solutions.',
    requirements: ['Healthcare IT', 'HIPAA compliance', 'AI/ML experience'],
    payRange: { min: 70, max: 100 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ['Healthcare IT', 'HIPAA', 'AI/ML', 'Telemedicine'], status: 'active',
    applicationsCount: 23, hiredCount: 98, referralBonus: 380,
    avatars: ['https://i.pravatar.cc/150?img=1','https://i.pravatar.cc/150?img=3','https://i.pravatar.cc/150?img=5'],
    createdAt: '2025-04-08'
  },
  {
    id: '48', companyId: '148', companyName: 'TextGen Labs',
    companyLogo: 'https://ui-avatars.com/api/?name=TextGen&background=7C3AED&color=fff',
    title: 'Prompt Engineer', category: 'AI & Machine Learning',
    description: 'Design and optimize prompts for large language models.',
    requirements: ['LLM experience', 'Creative writing', 'Systematic testing'],
    payRange: { min: 50, max: 80 }, payRate: 'hourly', location: 'Remote', type: 'Contract',
    skills: ['Prompt Engineering', 'LLMs', 'Testing', 'NLP'], status: 'active',
    applicationsCount: 95, hiredCount: 612, referralBonus: 250,
    avatars: ['https://i.pravatar.cc/150?img=7','https://i.pravatar.cc/150?img=9','https://i.pravatar.cc/150?img=11'],
    createdAt: '2025-04-10'
  },
  {
    id: '49', companyId: '149', companyName: 'AudioAI',
    companyLogo: 'https://ui-avatars.com/api/?name=AudioAI&background=F43F5E&color=fff',
    title: 'Audio ML Engineer', category: 'AI & Machine Learning',
    description: 'Build ML models for audio classification and generation.',
    requirements: ['Audio signal processing', 'Deep learning', 'Python'],
    payRange: { min: 80, max: 120 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ['Audio ML', 'Signal Processing', 'PyTorch', 'Python'], status: 'active',
    applicationsCount: 17, hiredCount: 67, referralBonus: 420,
    avatars: ['https://i.pravatar.cc/150?img=13','https://i.pravatar.cc/150?img=15'],
    createdAt: '2025-04-12'
  },
  {
    id: '50', companyId: '150', companyName: 'EduAI Global',
    companyLogo: 'https://ui-avatars.com/api/?name=EduAI&background=CA8A04&color=fff',
    title: 'Online Tutor - AI & Computer Science', category: 'Education',
    description: 'Teach AI and CS concepts through interactive online sessions.',
    requirements: ['Teaching experience', 'CS/AI degree', 'Communication skills'],
    payRange: { min: 40, max: 60 }, payRate: 'hourly', location: 'Remote', type: 'Part-time',
    skills: ['Teaching', 'AI/ML', 'Computer Science', 'Communication'], status: 'active',
    applicationsCount: 78, hiredCount: 445, referralBonus: 200,
    avatars: ['https://i.pravatar.cc/150?img=17','https://i.pravatar.cc/150?img=19','https://i.pravatar.cc/150?img=21'],
    createdAt: '2025-04-14'
  }
,
  {
    id: '51', companyId: '151', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Senior Backend Engineer (Python)', category: 'Software Engineering',
    description: 'Join our team as a Senior Backend Engineer (Python). Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 80, max: 130 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Python", "Django", "PostgreSQL", "Redis"], status: 'active',
    applicationsCount: 78, hiredCount: 234, referralBonus: 520,
    avatars: ['https://i.pravatar.cc/150?img=13','https://i.pravatar.cc/150?img=23','https://i.pravatar.cc/150?img=33'],
    createdAt: '2025-01-24'
  },
  {
    id: '52', companyId: '152', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Full Stack Developer (React/Node)', category: 'Software Engineering',
    description: 'Join our team as a Full Stack Developer (React/Node). Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 60, max: 100 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["React", "Node.js", "MongoDB", "TypeScript"], status: 'active',
    applicationsCount: 137, hiredCount: 412, referralBonus: 400,
    avatars: ['https://i.pravatar.cc/150?img=16','https://i.pravatar.cc/150?img=26','https://i.pravatar.cc/150?img=36'],
    createdAt: '2025-06-28'
  },
  {
    id: '53', companyId: '153', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Data Scientist (NLP)', category: 'AI & Machine Learning',
    description: 'Join our team as a Data Scientist (NLP). Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 90, max: 140 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["NLP", "Python", "Transformers", "PyTorch"], status: 'active',
    applicationsCount: 26, hiredCount: 78, referralBonus: 560,
    avatars: ['https://i.pravatar.cc/150?img=19','https://i.pravatar.cc/150?img=29','https://i.pravatar.cc/150?img=39'],
    createdAt: '2025-02-16'
  },
  {
    id: '54', companyId: '154', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Machine Learning Engineer', category: 'AI & Machine Learning',
    description: 'Join our team as a Machine Learning Engineer. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 100, max: 160 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["TensorFlow", "Python", "MLOps", "Kubernetes"], status: 'active',
    applicationsCount: 52, hiredCount: 156, referralBonus: 640,
    avatars: ['https://i.pravatar.cc/150?img=22','https://i.pravatar.cc/150?img=32','https://i.pravatar.cc/150?img=42'],
    createdAt: '2025-06-13'
  },
  {
    id: '55', companyId: '155', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'DevOps Engineer (Kubernetes)', category: 'Software Engineering',
    description: 'Join our team as a DevOps Engineer (Kubernetes). Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 85, max: 120 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Kubernetes", "Docker", "AWS", "Terraform"], status: 'active',
    applicationsCount: 31, hiredCount: 93, referralBonus: 480,
    avatars: ['https://i.pravatar.cc/150?img=25','https://i.pravatar.cc/150?img=35','https://i.pravatar.cc/150?img=45'],
    createdAt: '2025-01-22'
  },
  {
    id: '56', companyId: '156', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Product Manager (AI Products)', category: 'Consulting',
    description: 'Join our team as a Product Manager (AI Products). Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 110, max: 170 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Product Strategy", "AI/ML", "Agile", "Data Analysis"], status: 'active',
    applicationsCount: 11, hiredCount: 34, referralBonus: 680,
    avatars: ['https://i.pravatar.cc/150?img=28','https://i.pravatar.cc/150?img=38','https://i.pravatar.cc/150?img=48'],
    createdAt: '2025-02-11'
  },
  {
    id: '57', companyId: '157', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'UX Researcher', category: 'Media & Content',
    description: 'Join our team as a UX Researcher. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 55, max: 80 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["User Research", "Figma", "A/B Testing", "Analytics"], status: 'active',
    applicationsCount: 22, hiredCount: 67, referralBonus: 320,
    avatars: ['https://i.pravatar.cc/150?img=31','https://i.pravatar.cc/150?img=41','https://i.pravatar.cc/150?img=51'],
    createdAt: '2025-05-21'
  },
  {
    id: '58', companyId: '158', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Technical Writer (API Docs)', category: 'Media & Content',
    description: 'Join our team as a Technical Writer (API Docs). Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 40, max: 60 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["API Docs", "Markdown", "OpenAPI", "Git"], status: 'active',
    applicationsCount: 40, hiredCount: 122, referralBonus: 240,
    avatars: ['https://i.pravatar.cc/150?img=34','https://i.pravatar.cc/150?img=44','https://i.pravatar.cc/150?img=54'],
    createdAt: '2025-03-13'
  },
  {
    id: '59', companyId: '159', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Cybersecurity Analyst', category: 'Software Engineering',
    description: 'Join our team as a Cybersecurity Analyst. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 90, max: 130 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["SIEM", "Pentesting", "ISO 27001", "Python"], status: 'active',
    applicationsCount: 9, hiredCount: 28, referralBonus: 520,
    avatars: ['https://i.pravatar.cc/150?img=37','https://i.pravatar.cc/150?img=47','https://i.pravatar.cc/150?img=57'],
    createdAt: '2025-06-17'
  },
  {
    id: '60', companyId: '160', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Blockchain Developer (Solidity)', category: 'Software Engineering',
    description: 'Join our team as a Blockchain Developer (Solidity). Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 100, max: 180 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Solidity", "Ethereum", "Web3.js", "DeFi"], status: 'active',
    applicationsCount: 6, hiredCount: 19, referralBonus: 720,
    avatars: ['https://i.pravatar.cc/150?img=40','https://i.pravatar.cc/150?img=50','https://i.pravatar.cc/150?img=60'],
    createdAt: '2025-03-13'
  },
  {
    id: '61', companyId: '161', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Bilingual Spanish Evaluator', category: 'Data Science',
    description: 'Join our team as a Bilingual Spanish Evaluator. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 20, max: 30 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Spanish", "English", "QA", "Linguistics"], status: 'active',
    applicationsCount: 29, hiredCount: 89, referralBonus: 120,
    avatars: ['https://i.pravatar.cc/150?img=43','https://i.pravatar.cc/150?img=53','https://i.pravatar.cc/150?img=63'],
    createdAt: '2025-02-26'
  },
  {
    id: '62', companyId: '162', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Bilingual Japanese Evaluator', category: 'Data Science',
    description: 'Join our team as a Bilingual Japanese Evaluator. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 30, max: 45 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Japanese", "English", "NLP", "Annotation"], status: 'active',
    applicationsCount: 10, hiredCount: 32, referralBonus: 180,
    avatars: ['https://i.pravatar.cc/150?img=46','https://i.pravatar.cc/150?img=56','https://i.pravatar.cc/150?img=66'],
    createdAt: '2025-06-21'
  },
  {
    id: '63', companyId: '163', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Computer Vision Engineer', category: 'AI & Machine Learning',
    description: 'Join our team as a Computer Vision Engineer. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 95, max: 150 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["OpenCV", "PyTorch", "YOLO", "Vision"], status: 'active',
    applicationsCount: 14, hiredCount: 44, referralBonus: 600,
    avatars: ['https://i.pravatar.cc/150?img=49','https://i.pravatar.cc/150?img=59','https://i.pravatar.cc/150?img=69'],
    createdAt: '2025-02-20'
  },
  {
    id: '64', companyId: '164', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'RL Researcher', category: 'Research & Science',
    description: 'Join our team as a RL Researcher. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 100, max: 160 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["RL", "Python", "Gym", "Multi-Agent"], status: 'active',
    applicationsCount: 7, hiredCount: 23, referralBonus: 640,
    avatars: ['https://i.pravatar.cc/150?img=52','https://i.pravatar.cc/150?img=62','https://i.pravatar.cc/150?img=2'],
    createdAt: '2025-04-15'
  },
  {
    id: '65', companyId: '165', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Cloud Architect (AWS)', category: 'Software Engineering',
    description: 'Join our team as a Cloud Architect (AWS). Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 120, max: 180 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["AWS", "CloudFormation", "Lambda", "EKS"], status: 'active',
    applicationsCount: 22, hiredCount: 67, referralBonus: 720,
    avatars: ['https://i.pravatar.cc/150?img=55','https://i.pravatar.cc/150?img=65','https://i.pravatar.cc/150?img=5'],
    createdAt: '2025-02-21'
  },
  {
    id: '66', companyId: '166', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Cloud Architect (GCP)', category: 'Software Engineering',
    description: 'Join our team as a Cloud Architect (GCP). Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 115, max: 175 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["GCP", "BigQuery", "CloudRun", "K8s"], status: 'active',
    applicationsCount: 17, hiredCount: 52, referralBonus: 700,
    avatars: ['https://i.pravatar.cc/150?img=58','https://i.pravatar.cc/150?img=68','https://i.pravatar.cc/150?img=8'],
    createdAt: '2025-06-16'
  },
  {
    id: '67', companyId: '167', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Mobile Developer (Flutter)', category: 'Software Engineering',
    description: 'Join our team as a Mobile Developer (Flutter). Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 60, max: 100 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Flutter", "Dart", "Firebase", "Mobile"], status: 'active',
    applicationsCount: 44, hiredCount: 134, referralBonus: 400,
    avatars: ['https://i.pravatar.cc/150?img=61','https://i.pravatar.cc/150?img=1','https://i.pravatar.cc/150?img=11'],
    createdAt: '2025-06-23'
  },
  {
    id: '68', companyId: '168', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Mobile Dev (React Native)', category: 'Software Engineering',
    description: 'Join our team as a Mobile Dev (React Native). Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 65, max: 105 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["React Native", "JS", "Expo", "Redux"], status: 'active',
    applicationsCount: 63, hiredCount: 189, referralBonus: 420,
    avatars: ['https://i.pravatar.cc/150?img=64','https://i.pravatar.cc/150?img=4','https://i.pravatar.cc/150?img=14'],
    createdAt: '2025-01-26'
  },
  {
    id: '69', companyId: '169', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'QA Automation Engineer', category: 'Software Engineering',
    description: 'Join our team as a QA Automation Engineer. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 50, max: 80 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Selenium", "Cypress", "Python", "CI/CD"], status: 'active',
    applicationsCount: 26, hiredCount: 78, referralBonus: 320,
    avatars: ['https://i.pravatar.cc/150?img=67','https://i.pravatar.cc/150?img=7','https://i.pravatar.cc/150?img=17'],
    createdAt: '2025-04-10'
  },
  {
    id: '70', companyId: '170', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'DBA (PostgreSQL)', category: 'Software Engineering',
    description: 'Join our team as a DBA (PostgreSQL). Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 70, max: 110 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["PostgreSQL", "MySQL", "Redis", "Migration"], status: 'active',
    applicationsCount: 11, hiredCount: 34, referralBonus: 440,
    avatars: ['https://i.pravatar.cc/150?img=0','https://i.pravatar.cc/150?img=10','https://i.pravatar.cc/150?img=20'],
    createdAt: '2025-03-19'
  },
  {
    id: '71', companyId: '171', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Epidemiologist', category: 'Healthcare',
    description: 'Join our team as a Epidemiologist. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 80, max: 120 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Epidemiology", "Biostatistics", "R", "SAS"], status: 'active',
    applicationsCount: 5, hiredCount: 15, referralBonus: 480,
    avatars: ['https://i.pravatar.cc/150?img=3','https://i.pravatar.cc/150?img=13','https://i.pravatar.cc/150?img=23'],
    createdAt: '2025-06-22'
  },
  {
    id: '72', companyId: '172', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Clinical Data Analyst', category: 'Healthcare',
    description: 'Join our team as a Clinical Data Analyst. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 60, max: 90 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Clinical Trials", "SAS", "CDISC", "SQL"], status: 'active',
    applicationsCount: 9, hiredCount: 29, referralBonus: 360,
    avatars: ['https://i.pravatar.cc/150?img=6','https://i.pravatar.cc/150?img=16','https://i.pravatar.cc/150?img=26'],
    createdAt: '2025-05-12'
  },
  {
    id: '73', companyId: '173', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Radiologist (AI)', category: 'Healthcare',
    description: 'Join our team as a Radiologist (AI). Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 140, max: 200 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Radiology", "DICOM", "AI Imaging", "Path"], status: 'active',
    applicationsCount: 4, hiredCount: 12, referralBonus: 800,
    avatars: ['https://i.pravatar.cc/150?img=9','https://i.pravatar.cc/150?img=19','https://i.pravatar.cc/150?img=29'],
    createdAt: '2025-02-15'
  },
  {
    id: '74', companyId: '174', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Dermatologist', category: 'Healthcare',
    description: 'Join our team as a Dermatologist. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 130, max: 160 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Derm", "Telemedicine", "Imaging", "AI Dx"], status: 'active',
    applicationsCount: 6, hiredCount: 18, referralBonus: 640,
    avatars: ['https://i.pravatar.cc/150?img=12','https://i.pravatar.cc/150?img=22','https://i.pravatar.cc/150?img=32'],
    createdAt: '2025-01-12'
  },
  {
    id: '75', companyId: '175', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Prompt Engineer', category: 'AI & Machine Learning',
    description: 'Join our team as a Prompt Engineer. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 50, max: 90 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Prompt Design", "LLMs", "GPT", "CoT"], status: 'active',
    applicationsCount: 78, hiredCount: 234, referralBonus: 360,
    avatars: ['https://i.pravatar.cc/150?img=15','https://i.pravatar.cc/150?img=25','https://i.pravatar.cc/150?img=35'],
    createdAt: '2025-05-15'
  },
  {
    id: '76', companyId: '176', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'AI Safety Researcher', category: 'Research & Science',
    description: 'Join our team as a AI Safety Researcher. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 110, max: 180 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Safety", "Alignment", "RLHF", "Ethics"], status: 'active',
    applicationsCount: 4, hiredCount: 14, referralBonus: 720,
    avatars: ['https://i.pravatar.cc/150?img=18','https://i.pravatar.cc/150?img=28','https://i.pravatar.cc/150?img=38'],
    createdAt: '2025-04-24'
  },
  {
    id: '77', companyId: '177', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Robotics Engineer', category: 'Software Engineering',
    description: 'Join our team as a Robotics Engineer. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 90, max: 150 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["ROS", "C++", "Python", "Sensors"], status: 'active',
    applicationsCount: 7, hiredCount: 21, referralBonus: 600,
    avatars: ['https://i.pravatar.cc/150?img=21','https://i.pravatar.cc/150?img=31','https://i.pravatar.cc/150?img=41'],
    createdAt: '2025-04-22'
  },
  {
    id: '78', companyId: '178', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Embedded Systems Eng', category: 'Software Engineering',
    description: 'Join our team as a Embedded Systems Eng. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 75, max: 120 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["C/C++", "RTOS", "ARM", "IoT"], status: 'active',
    applicationsCount: 12, hiredCount: 38, referralBonus: 480,
    avatars: ['https://i.pravatar.cc/150?img=24','https://i.pravatar.cc/150?img=34','https://i.pravatar.cc/150?img=44'],
    createdAt: '2025-04-10'
  },
  {
    id: '79', companyId: '179', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Biostatistician', category: 'Research & Science',
    description: 'Join our team as a Biostatistician. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 70, max: 110 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["R", "SAS", "Clinical", "Bayesian"], status: 'active',
    applicationsCount: 8, hiredCount: 24, referralBonus: 440,
    avatars: ['https://i.pravatar.cc/150?img=27','https://i.pravatar.cc/150?img=37','https://i.pravatar.cc/150?img=47'],
    createdAt: '2025-06-17'
  },
  {
    id: '80', companyId: '180', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Chemistry PhD (Organic)', category: 'Research & Science',
    description: 'Join our team as a Chemistry PhD (Organic). Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 60, max: 85 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Organic Chem", "NMR", "Synthesis", "Lab"], status: 'active',
    applicationsCount: 10, hiredCount: 31, referralBonus: 340,
    avatars: ['https://i.pravatar.cc/150?img=30','https://i.pravatar.cc/150?img=40','https://i.pravatar.cc/150?img=50'],
    createdAt: '2025-02-20'
  },
  {
    id: '81', companyId: '181', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Neuroscience Researcher', category: 'Research & Science',
    description: 'Join our team as a Neuroscience Researcher. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 75, max: 100 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Neuro", "fMRI", "EEG", "Python"], status: 'active',
    applicationsCount: 5, hiredCount: 16, referralBonus: 400,
    avatars: ['https://i.pravatar.cc/150?img=33','https://i.pravatar.cc/150?img=43','https://i.pravatar.cc/150?img=53'],
    createdAt: '2025-02-24'
  },
  {
    id: '82', companyId: '182', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Genomics Expert', category: 'Research & Science',
    description: 'Join our team as a Genomics Expert. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 80, max: 120 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Genomics", "CRISPR", "Bioinfo", "NGS"], status: 'active',
    applicationsCount: 7, hiredCount: 22, referralBonus: 480,
    avatars: ['https://i.pravatar.cc/150?img=36','https://i.pravatar.cc/150?img=46','https://i.pravatar.cc/150?img=56'],
    createdAt: '2025-04-18'
  },
  {
    id: '83', companyId: '183', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Quant Financial Analyst', category: 'Consulting',
    description: 'Join our team as a Quant Financial Analyst. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 80, max: 130 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Quant", "Python", "Bloomberg", "Risk"], status: 'active',
    applicationsCount: 14, hiredCount: 42, referralBonus: 520,
    avatars: ['https://i.pravatar.cc/150?img=39','https://i.pravatar.cc/150?img=49','https://i.pravatar.cc/150?img=59'],
    createdAt: '2025-06-20'
  },
  {
    id: '84', companyId: '184', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'SEO Content Strategist', category: 'Media & Content',
    description: 'Join our team as a SEO Content Strategist. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 35, max: 55 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["SEO", "Content", "Analytics", "Keywords"], status: 'active',
    applicationsCount: 32, hiredCount: 98, referralBonus: 220,
    avatars: ['https://i.pravatar.cc/150?img=42','https://i.pravatar.cc/150?img=52','https://i.pravatar.cc/150?img=62'],
    createdAt: '2025-06-28'
  },
  {
    id: '85', companyId: '185', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Video Editor (AI)', category: 'Media & Content',
    description: 'Join our team as a Video Editor (AI). Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 30, max: 50 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Premiere", "AfterEffects", "DaVinci", "AI"], status: 'active',
    applicationsCount: 48, hiredCount: 145, referralBonus: 200,
    avatars: ['https://i.pravatar.cc/150?img=45','https://i.pravatar.cc/150?img=55','https://i.pravatar.cc/150?img=65'],
    createdAt: '2025-04-23'
  },
  {
    id: '86', companyId: '186', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Motion Graphics Designer', category: 'Media & Content',
    description: 'Join our team as a Motion Graphics Designer. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 40, max: 65 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["AE", "Cinema4D", "Blender", "Animation"], status: 'active',
    applicationsCount: 22, hiredCount: 67, referralBonus: 260,
    avatars: ['https://i.pravatar.cc/150?img=48','https://i.pravatar.cc/150?img=58','https://i.pravatar.cc/150?img=68'],
    createdAt: '2025-02-26'
  },
  {
    id: '87', companyId: '187', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: '3D Artist (Blender)', category: 'Media & Content',
    description: 'Join our team as a 3D Artist (Blender). Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 45, max: 75 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Blender", "Maya", "ZBrush", "Textures"], status: 'active',
    applicationsCount: 11, hiredCount: 34, referralBonus: 300,
    avatars: ['https://i.pravatar.cc/150?img=51','https://i.pravatar.cc/150?img=61','https://i.pravatar.cc/150?img=1'],
    createdAt: '2025-02-10'
  },
  {
    id: '88', companyId: '188', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Game Designer (Unity)', category: 'Software Engineering',
    description: 'Join our team as a Game Designer (Unity). Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 50, max: 85 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Unity", "C#", "GameDesign", "Levels"], status: 'active',
    applicationsCount: 7, hiredCount: 23, referralBonus: 340,
    avatars: ['https://i.pravatar.cc/150?img=54','https://i.pravatar.cc/150?img=64','https://i.pravatar.cc/150?img=4'],
    createdAt: '2025-03-12'
  },
  {
    id: '89', companyId: '189', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'MLOps Engineer', category: 'AI & Machine Learning',
    description: 'Join our team as a MLOps Engineer. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 90, max: 140 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["MLflow", "Kubeflow", "Docker", "CI/CD"], status: 'active',
    applicationsCount: 18, hiredCount: 56, referralBonus: 560,
    avatars: ['https://i.pravatar.cc/150?img=57','https://i.pravatar.cc/150?img=67','https://i.pravatar.cc/150?img=7'],
    createdAt: '2025-04-23'
  },
  {
    id: '90', companyId: '190', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'NLP Expert', category: 'AI & Machine Learning',
    description: 'Join our team as a NLP Expert. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 95, max: 150 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["NLP", "BERT", "Transformers", "spaCy"], status: 'active',
    applicationsCount: 11, hiredCount: 34, referralBonus: 600,
    avatars: ['https://i.pravatar.cc/150?img=60','https://i.pravatar.cc/150?img=0','https://i.pravatar.cc/150?img=10'],
    createdAt: '2025-01-25'
  },
  {
    id: '91', companyId: '191', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Conversational AI Dev', category: 'AI & Machine Learning',
    description: 'Join our team as a Conversational AI Dev. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 60, max: 95 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Dialogflow", "Rasa", "UXWrite", "NLU"], status: 'active',
    applicationsCount: 15, hiredCount: 45, referralBonus: 380,
    avatars: ['https://i.pravatar.cc/150?img=63','https://i.pravatar.cc/150?img=3','https://i.pravatar.cc/150?img=13'],
    createdAt: '2025-06-11'
  },
  {
    id: '92', companyId: '192', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Autonomous Driving Eng', category: 'AI & Machine Learning',
    description: 'Join our team as a Autonomous Driving Eng. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 120, max: 190 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["LiDAR", "CV", "ROS", "Sensors"], status: 'active',
    applicationsCount: 3, hiredCount: 11, referralBonus: 760,
    avatars: ['https://i.pravatar.cc/150?img=66','https://i.pravatar.cc/150?img=6','https://i.pravatar.cc/150?img=16'],
    createdAt: '2025-04-16'
  },
  {
    id: '93', companyId: '193', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Speech Recognition Eng', category: 'AI & Machine Learning',
    description: 'Join our team as a Speech Recognition Eng. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 85, max: 130 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["ASR", "Whisper", "DeepSpeech", "Py"], status: 'active',
    applicationsCount: 7, hiredCount: 23, referralBonus: 520,
    avatars: ['https://i.pravatar.cc/150?img=69','https://i.pravatar.cc/150?img=9','https://i.pravatar.cc/150?img=19'],
    createdAt: '2025-06-23'
  },
  {
    id: '94', companyId: '194', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Bioinformatics Scientist', category: 'Research & Science',
    description: 'Join our team as a Bioinformatics Scientist. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 75, max: 110 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Bioinfo", "Python", "R", "Genomics"], status: 'active',
    applicationsCount: 6, hiredCount: 18, referralBonus: 440,
    avatars: ['https://i.pravatar.cc/150?img=2','https://i.pravatar.cc/150?img=12','https://i.pravatar.cc/150?img=22'],
    createdAt: '2025-03-22'
  },
  {
    id: '95', companyId: '195', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Math Expert (Topology)', category: 'Research & Science',
    description: 'Join our team as a Math Expert (Topology). Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 65, max: 90 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Topology", "Algebra", "LaTeX", "Proofs"], status: 'active',
    applicationsCount: 4, hiredCount: 14, referralBonus: 360,
    avatars: ['https://i.pravatar.cc/150?img=5','https://i.pravatar.cc/150?img=15','https://i.pravatar.cc/150?img=25'],
    createdAt: '2025-05-22'
  },
  {
    id: '96', companyId: '196', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Systems Programmer (Rust)', category: 'Software Engineering',
    description: 'Join our team as a Systems Programmer (Rust). Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 100, max: 160 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Rust", "Systems", "Memory", "Conc"], status: 'active',
    applicationsCount: 9, hiredCount: 28, referralBonus: 640,
    avatars: ['https://i.pravatar.cc/150?img=8','https://i.pravatar.cc/150?img=18','https://i.pravatar.cc/150?img=28'],
    createdAt: '2025-02-11'
  },
  {
    id: '97', companyId: '197', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Systems Programmer (C++)', category: 'Software Engineering',
    description: 'Join our team as a Systems Programmer (C++). Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 90, max: 150 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["C++", "STL", "Perf", "Linux"], status: 'active',
    applicationsCount: 15, hiredCount: 45, referralBonus: 600,
    avatars: ['https://i.pravatar.cc/150?img=11','https://i.pravatar.cc/150?img=21','https://i.pravatar.cc/150?img=31'],
    createdAt: '2025-05-23'
  },
  {
    id: '98', companyId: '198', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'SRE Engineer', category: 'Software Engineering',
    description: 'Join our team as a SRE Engineer. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 95, max: 140 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["SRE", "Prometheus", "Grafana", "Linux"], status: 'active',
    applicationsCount: 18, hiredCount: 56, referralBonus: 560,
    avatars: ['https://i.pravatar.cc/150?img=14','https://i.pravatar.cc/150?img=24','https://i.pravatar.cc/150?img=34'],
    createdAt: '2025-01-12'
  },
  {
    id: '99', companyId: '199', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Technical Program Mgr', category: 'Consulting',
    description: 'Join our team as a Technical Program Mgr. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 100, max: 160 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["PgM", "Agile", "Stakeholders", "Risk"], status: 'active',
    applicationsCount: 8, hiredCount: 24, referralBonus: 640,
    avatars: ['https://i.pravatar.cc/150?img=17','https://i.pravatar.cc/150?img=27','https://i.pravatar.cc/150?img=37'],
    createdAt: '2025-03-17'
  },
  {
    id: '100', companyId: '1100', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Growth Marketing Analyst', category: 'Consulting',
    description: 'Join our team as a Growth Marketing Analyst. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 45, max: 70 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Growth", "Analytics", "SQL", "A/B"], status: 'active',
    applicationsCount: 29, hiredCount: 87, referralBonus: 280,
    avatars: ['https://i.pravatar.cc/150?img=20','https://i.pravatar.cc/150?img=30','https://i.pravatar.cc/150?img=40'],
    createdAt: '2025-06-14'
  },
  {
    id: '101', companyId: '1101', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Supply Chain Analyst', category: 'Operations',
    description: 'Join our team as a Supply Chain Analyst. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 40, max: 65 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Supply Chain", "Excel", "SAP", "Forecast"], status: 'active',
    applicationsCount: 11, hiredCount: 33, referralBonus: 260,
    avatars: ['https://i.pravatar.cc/150?img=23','https://i.pravatar.cc/150?img=33','https://i.pravatar.cc/150?img=43'],
    createdAt: '2025-02-15'
  },
  {
    id: '102', companyId: '1102', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Operations Research', category: 'Operations',
    description: 'Join our team as a Operations Research. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 55, max: 85 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["OR", "LP", "Python", "Optimization"], status: 'active',
    applicationsCount: 7, hiredCount: 21, referralBonus: 340,
    avatars: ['https://i.pravatar.cc/150?img=26','https://i.pravatar.cc/150?img=36','https://i.pravatar.cc/150?img=46'],
    createdAt: '2025-01-25'
  },
  {
    id: '103', companyId: '1103', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Patent Attorney (Tech)', category: 'Consulting',
    description: 'Join our team as a Patent Attorney (Tech). Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 120, max: 200 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Patent", "IP", "Licensing", "USPTO"], status: 'active',
    applicationsCount: 3, hiredCount: 9, referralBonus: 800,
    avatars: ['https://i.pravatar.cc/150?img=29','https://i.pravatar.cc/150?img=39','https://i.pravatar.cc/150?img=49'],
    createdAt: '2025-05-10'
  },
  {
    id: '104', companyId: '1104', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Clinical Pharmacist', category: 'Healthcare',
    description: 'Join our team as a Clinical Pharmacist. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 90, max: 130 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Pharmacology", "GCP", "Regulatory", "Safety"], status: 'active',
    applicationsCount: 4, hiredCount: 14, referralBonus: 520,
    avatars: ['https://i.pravatar.cc/150?img=32','https://i.pravatar.cc/150?img=42','https://i.pravatar.cc/150?img=52'],
    createdAt: '2025-06-13'
  },
  {
    id: '105', companyId: '1105', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Physical Therapist', category: 'Healthcare',
    description: 'Join our team as a Physical Therapist. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 50, max: 75 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["PT", "Rehab", "Telehealth", "Exercise"], status: 'active',
    applicationsCount: 12, hiredCount: 38, referralBonus: 300,
    avatars: ['https://i.pravatar.cc/150?img=35','https://i.pravatar.cc/150?img=45','https://i.pravatar.cc/150?img=55'],
    createdAt: '2025-04-26'
  },
  {
    id: '106', companyId: '1106', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Creative Copywriter', category: 'Media & Content',
    description: 'Join our team as a Creative Copywriter. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 35, max: 55 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Copy", "Brand", "Content", "Story"], status: 'active',
    applicationsCount: 52, hiredCount: 156, referralBonus: 220,
    avatars: ['https://i.pravatar.cc/150?img=38','https://i.pravatar.cc/150?img=48','https://i.pravatar.cc/150?img=58'],
    createdAt: '2025-01-16'
  },
  {
    id: '107', companyId: '1107', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'AI/ML Blog Writer', category: 'Media & Content',
    description: 'Join our team as a AI/ML Blog Writer. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 40, max: 60 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["TechWriting", "AI/ML", "SEO", "Research"], status: 'active',
    applicationsCount: 29, hiredCount: 89, referralBonus: 240,
    avatars: ['https://i.pravatar.cc/150?img=41','https://i.pravatar.cc/150?img=51','https://i.pravatar.cc/150?img=61'],
    createdAt: '2025-02-21'
  },
  {
    id: '108', companyId: '1108', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Localization Specialist', category: 'Media & Content',
    description: 'Join our team as a Localization Specialist. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 30, max: 50 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["L10n", "Translation", "CAT", "QA"], status: 'active',
    applicationsCount: 22, hiredCount: 67, referralBonus: 200,
    avatars: ['https://i.pravatar.cc/150?img=44','https://i.pravatar.cc/150?img=54','https://i.pravatar.cc/150?img=64'],
    createdAt: '2025-03-17'
  },
  {
    id: '109', companyId: '1109', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Data Engineer (Spark)', category: 'Software Engineering',
    description: 'Join our team as a Data Engineer (Spark). Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 85, max: 130 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Spark", "Airflow", "Python", "Pipes"], status: 'active',
    applicationsCount: 22, hiredCount: 67, referralBonus: 520,
    avatars: ['https://i.pravatar.cc/150?img=47','https://i.pravatar.cc/150?img=57','https://i.pravatar.cc/150?img=67'],
    createdAt: '2025-01-27'
  },
  {
    id: '110', companyId: '1110', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Frontend Eng (Vue.js)', category: 'Software Engineering',
    description: 'Join our team as a Frontend Eng (Vue.js). Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 55, max: 90 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Vue.js", "JS", "CSS", "Vuex"], status: 'active',
    applicationsCount: 29, hiredCount: 88, referralBonus: 360,
    avatars: ['https://i.pravatar.cc/150?img=50','https://i.pravatar.cc/150?img=60','https://i.pravatar.cc/150?img=0'],
    createdAt: '2025-04-21'
  },
  {
    id: '111', companyId: '1111', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Frontend Eng (Angular)', category: 'Software Engineering',
    description: 'Join our team as a Frontend Eng (Angular). Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 55, max: 90 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Angular", "TS", "RxJS", "NgRx"], status: 'active',
    applicationsCount: 24, hiredCount: 72, referralBonus: 360,
    avatars: ['https://i.pravatar.cc/150?img=53','https://i.pravatar.cc/150?img=63','https://i.pravatar.cc/150?img=3'],
    createdAt: '2025-05-19'
  },
  {
    id: '112', companyId: '1112', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'UI/UX Designer (Figma)', category: 'Media & Content',
    description: 'Join our team as a UI/UX Designer (Figma). Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 50, max: 80 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Figma", "Design", "Proto", "Testing"], status: 'active',
    applicationsCount: 48, hiredCount: 145, referralBonus: 320,
    avatars: ['https://i.pravatar.cc/150?img=56','https://i.pravatar.cc/150?img=66','https://i.pravatar.cc/150?img=6'],
    createdAt: '2025-04-22'
  },
  {
    id: '113', companyId: '1113', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Digital Illustrator', category: 'Media & Content',
    description: 'Join our team as a Digital Illustrator. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 35, max: 55 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Illustrator", "Procreate", "Art", "Design"], status: 'active',
    applicationsCount: 26, hiredCount: 78, referralBonus: 220,
    avatars: ['https://i.pravatar.cc/150?img=59','https://i.pravatar.cc/150?img=69','https://i.pravatar.cc/150?img=9'],
    createdAt: '2025-05-25'
  },
  {
    id: '114', companyId: '1114', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'VR/AR Developer', category: 'Software Engineering',
    description: 'Join our team as a VR/AR Developer. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 70, max: 110 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Unity", "C#", "VR/AR", "3D"], status: 'active',
    applicationsCount: 5, hiredCount: 15, referralBonus: 440,
    avatars: ['https://i.pravatar.cc/150?img=62','https://i.pravatar.cc/150?img=2','https://i.pravatar.cc/150?img=12'],
    createdAt: '2025-06-27'
  },
  {
    id: '115', companyId: '1115', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Bilingual Arabic Expert', category: 'Data Science',
    description: 'Join our team as a Bilingual Arabic Expert. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 20, max: 35 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Arabic", "English", "QA", "Annotation"], status: 'active',
    applicationsCount: 21, hiredCount: 63, referralBonus: 140,
    avatars: ['https://i.pravatar.cc/150?img=65','https://i.pravatar.cc/150?img=5','https://i.pravatar.cc/150?img=15'],
    createdAt: '2025-06-18'
  },
  {
    id: '116', companyId: '1116', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Bilingual Hindi Expert', category: 'Data Science',
    description: 'Join our team as a Bilingual Hindi Expert. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 15, max: 25 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Hindi", "English", "Translation", "QA"], status: 'active',
    applicationsCount: 26, hiredCount: 78, referralBonus: 100,
    avatars: ['https://i.pravatar.cc/150?img=68','https://i.pravatar.cc/150?img=8','https://i.pravatar.cc/150?img=18'],
    createdAt: '2025-05-28'
  },
  {
    id: '117', companyId: '1117', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Bilingual French Expert', category: 'Data Science',
    description: 'Join our team as a Bilingual French Expert. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 25, max: 37 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["French", "English", "Linguistics", "QA"], status: 'active',
    applicationsCount: 15, hiredCount: 47, referralBonus: 150,
    avatars: ['https://i.pravatar.cc/150?img=1','https://i.pravatar.cc/150?img=11','https://i.pravatar.cc/150?img=21'],
    createdAt: '2025-05-22'
  },
  {
    id: '118', companyId: '1118', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Bilingual German Expert', category: 'Data Science',
    description: 'Join our team as a Bilingual German Expert. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 25, max: 30 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["German", "English", "Linguistics", "QA"], status: 'active',
    applicationsCount: 9, hiredCount: 27, referralBonus: 120,
    avatars: ['https://i.pravatar.cc/150?img=4','https://i.pravatar.cc/150?img=14','https://i.pravatar.cc/150?img=24'],
    createdAt: '2025-05-28'
  },
  {
    id: '119', companyId: '1119', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Bilingual Portuguese Expert', category: 'Data Science',
    description: 'Join our team as a Bilingual Portuguese Expert. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 12, max: 30 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Portuguese", "English", "Trans", "QA"], status: 'active',
    applicationsCount: 3, hiredCount: 11, referralBonus: 120,
    avatars: ['https://i.pravatar.cc/150?img=7','https://i.pravatar.cc/150?img=17','https://i.pravatar.cc/150?img=27'],
    createdAt: '2025-01-24'
  },
  {
    id: '120', companyId: '1120', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Bilingual Mandarin Expert', category: 'Data Science',
    description: 'Join our team as a Bilingual Mandarin Expert. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 25, max: 38 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Mandarin", "English", "NLP", "Annot"], status: 'active',
    applicationsCount: 18, hiredCount: 56, referralBonus: 150,
    avatars: ['https://i.pravatar.cc/150?img=10','https://i.pravatar.cc/150?img=20','https://i.pravatar.cc/150?img=30'],
    createdAt: '2025-05-27'
  },
  {
    id: '121', companyId: '1121', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Bilingual Russian Expert', category: 'Data Science',
    description: 'Join our team as a Bilingual Russian Expert. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 22, max: 35 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Russian", "English", "Trans", "QA"], status: 'active',
    applicationsCount: 14, hiredCount: 44, referralBonus: 140,
    avatars: ['https://i.pravatar.cc/150?img=13','https://i.pravatar.cc/150?img=23','https://i.pravatar.cc/150?img=33'],
    createdAt: '2025-03-11'
  },
  {
    id: '122', companyId: '1122', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Bilingual Turkish Expert', category: 'Data Science',
    description: 'Join our team as a Bilingual Turkish Expert. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 18, max: 28 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Turkish", "English", "Linguistics", "QA"], status: 'active',
    applicationsCount: 11, hiredCount: 35, referralBonus: 110,
    avatars: ['https://i.pravatar.cc/150?img=16','https://i.pravatar.cc/150?img=26','https://i.pravatar.cc/150?img=36'],
    createdAt: '2025-06-15'
  },
  {
    id: '123', companyId: '1123', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Bilingual Vietnamese Expert', category: 'Data Science',
    description: 'Join our team as a Bilingual Vietnamese Expert. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 15, max: 25 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Vietnamese", "English", "Trans", "QA"], status: 'active',
    applicationsCount: 9, hiredCount: 29, referralBonus: 100,
    avatars: ['https://i.pravatar.cc/150?img=19','https://i.pravatar.cc/150?img=29','https://i.pravatar.cc/150?img=39'],
    createdAt: '2025-05-28'
  },
  {
    id: '124', companyId: '1124', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Bilingual Italian Expert', category: 'Data Science',
    description: 'Join our team as a Bilingual Italian Expert. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 25, max: 30 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Italian", "English", "Linguistics", "QA"], status: 'active',
    applicationsCount: 2, hiredCount: 8, referralBonus: 120,
    avatars: ['https://i.pravatar.cc/150?img=22','https://i.pravatar.cc/150?img=32','https://i.pravatar.cc/150?img=42'],
    createdAt: '2025-04-10'
  },
  {
    id: '125', companyId: '1125', companyName: 'Duty AI',
    companyLogo: 'https://ui-avatars.com/api/?name=Duty+AI&background=0A3900&color=fff',
    title: 'Bilingual Korean Expert', category: 'Data Science',
    description: 'Join our team as a Bilingual Korean Expert. Remote, flexible opportunity working on impactful projects.',
    requirements: ['Proven domain experience', 'Strong analytical skills', 'Remote collaboration'],
    payRange: { min: 28, max: 40 }, payRate: 'hourly', location: 'Remote', type: 'Full-time',
    skills: ["Korean", "English", "QA", "Trans"], status: 'active',
    applicationsCount: 13, hiredCount: 41, referralBonus: 160,
    avatars: ['https://i.pravatar.cc/150?img=25','https://i.pravatar.cc/150?img=35','https://i.pravatar.cc/150?img=45'],
    createdAt: '2025-06-21'
  }
];

export const testimonials = [
  {
    id: '1',
    name: 'Milton',
    role: 'Interventional Radiologist',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop',
    featured: true,
    order: 1
  },
  {
    id: '2',
    name: 'Angela',
    role: 'Medical Researcher',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop',
    featured: true,
    order: 2
  },
  {
    id: '3',
    name: 'Ruby',
    role: 'Biotech Research Scientist',
    image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400&h=400&fit=crop',
    featured: true,
    order: 3
  }
];

export const stats = [
  { label: 'Average pay', value: '$78/hr' },
  { label: 'Roles created', value: '78.5k' },
  { label: 'Daily payouts', value: '$1.5M+' }
];

export const applications = [
  {
    id: 'app1',
    jobId: '1',
    candidateId: '1',
    candidateName: 'John Doe',
    candidateEmail: 'john.doe@example.com',
    coverLetter: 'I am very interested in this position...',
    status: 'pending',
    appliedAt: '2025-01-26',
    job: jobListings[0]
  },
  {
    id: 'app2',
    jobId: '2',
    candidateId: '1',
    candidateName: 'John Doe',
    candidateEmail: 'john.doe@example.com',
    coverLetter: 'My experience aligns perfectly...',
    status: 'reviewing',
    appliedAt: '2025-01-24',
    job: jobListings[1]
  }
];

export const blogPosts = [
  {
    id: '1',
    title: 'The AI Productivity Index',
    slug: 'ai-productivity-index',
    excerpt: 'Analyzing the impact of AI on workplace productivity across industries.',
    content: 'Full blog content here...',
    author: 'Duty AI Research Team',
    readTime: '5 min read',
    tags: ['AI', 'Productivity', 'Research'],
    coverImage: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&h=400&fit=crop',
    published: true,
    publishedAt: '2025-01-20',
    createdAt: '2025-01-20'
  },
  {
    id: '2',
    title: 'The Future of Remote Work in AI',
    slug: 'future-remote-work-ai',
    excerpt: 'How AI is transforming the way we work remotely.',
    content: 'Full blog content here...',
    author: 'Sarah Johnson',
    readTime: '8 min read',
    tags: ['Remote Work', 'AI', 'Future of Work'],
    coverImage: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=800&h=400&fit=crop',
    published: true,
    publishedAt: '2025-01-15',
    createdAt: '2025-01-15'
  },
  {
    id: '3',
    title: 'Building AI Teams: Best Practices',
    slug: 'building-ai-teams',
    excerpt: 'Essential strategies for assembling high-performing AI teams.',
    content: 'Full blog content here...',
    author: 'Michael Chen',
    readTime: '6 min read',
    tags: ['Teams', 'AI', 'Management'],
    coverImage: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&h=400&fit=crop',
    published: true,
    publishedAt: '2025-01-10',
    createdAt: '2025-01-10'
  }
];

export const adminStats = {
  totalJobs: 156,
  activeJobs: 89,
  totalApplications: 2341,
  pendingApplications: 456,
  totalUsers: 8923,
  newUsersThisMonth: 342,
  totalCompanies: 234,
  totalCandidates: 8689
};
